import { render } from "./UpdateOpportunity.vue?vue&type=template&id=0d82c994"
import script from "./UpdateOpportunity.vue?vue&type=script&lang=js"
export * from "./UpdateOpportunity.vue?vue&type=script&lang=js"
script.render = render

export default script